export interface TreeNode {
  id: number;
  name: string;
  direct_children?: TreeNode[];
}

export const SHOW_MORE_NODE = {
  id: null,
  name: 'Show More',
};

export interface FlatNode {
  id: number;
  /**
   * Whether the node is expandable.
   */
  expandable: boolean;

  /**
   * The name of the node.
   */
  name: string;

  /**
   * The level of the node. 0 means it's the root node.
   */
  level: number;
}
